import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import { initSentry } from './lib/sentry'
import { SentryErrorBoundary } from './components/SentryErrorBoundary'
import { applyDomPatches } from './utils/domPatch'

applyDomPatches()
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary>
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
)